const cookieHub = {
	el: {
		btn: document.querySelectorAll('.js-set-hub')
	},

	vars: {
		selectedHubsValues: ['agenda-fiscal','irs', 'imi', 'imt', 'iuc']
	},

	async fxSetCookieHub (value) {
		try {
			await cookieStore.set({
				name: 'selectedHub',
				value: value,
				sameSite: 'none'
			})
		} catch (error) {
			console.log('error setting selectedHub')
		}		
	},

	async fxGetCookieHub () {
		let hub = await cookieStore.get('selectedHub')
		return hub
	},

	async fxRemoveCookieHub () {
		await cookieStore.delete('selectedHub')
	},

	fxCheckURL () {
		for(const value of this.vars.selectedHubsValues) {
			if(this.fxGetCookieHub() !== undefined && window.location.pathname.includes(value)) {
				this.fxRemoveCookieHub()
			}
		}
	},

	events() {
		//set hub cookie
		for (const btn of this.el.btn) {
			btn.addEventListener('click', e => {
				this.fxSetCookieHub(e.currentTarget.dataset.setHub)
			})
		}
		//remove hub cookie after login/register
		this.fxCheckURL()
	},

	init() {
		this.events()
	}
}

cookieHub.init()